module.exports = __webpack_public_path__ + "static/img/b-logo.bb982e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/b-logo.png
// module id = QNXb
// module chunks = 1